/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './past-medical-history.reducer';

export const PastMedicalHistoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pastMedicalHistoryEntity = useAppSelector(state => state.pastMedicalHistory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pastMedicalHistoryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pastMedicalHistory.detail.title">PastMedicalHistory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pastMedicalHistory.id">Id</Translate>
            </span>
          </dt>
          <dd>{pastMedicalHistoryEntity.id}</dd>
          <dt>
            <span id="illness">
              <Translate contentKey="tinyMedicRestApp.pastMedicalHistory.illness">Illness</Translate>
            </span>
          </dt>
          <dd>{pastMedicalHistoryEntity.illness ? 'true' : 'false'}</dd>
          <dt>
            <span id="illnessDetails">
              <Translate contentKey="tinyMedicRestApp.pastMedicalHistory.illnessDetails">Illness Details</Translate>
            </span>
          </dt>
          <dd>{pastMedicalHistoryEntity.illnessDetails}</dd>
          <dt>
            <span id="illnessStartDate">
              <Translate contentKey="tinyMedicRestApp.pastMedicalHistory.illnessStartDate">Illness Start Date</Translate>
            </span>
          </dt>
          <dd>{pastMedicalHistoryEntity.illnessStartDate}</dd>
          <dt>
            <span id="illnessEndDate">
              <Translate contentKey="tinyMedicRestApp.pastMedicalHistory.illnessEndDate">Illness End Date</Translate>
            </span>
          </dt>
          <dd>{pastMedicalHistoryEntity.illnessEndDate}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pastMedicalHistory.active">Active</Translate>
            </span>
          </dt>
          <dd>{pastMedicalHistoryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.pastMedicalHistory.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{pastMedicalHistoryEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pastMedicalHistory.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pastMedicalHistoryEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pastMedicalHistory.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{pastMedicalHistoryEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pastMedicalHistory.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pastMedicalHistoryEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.pastMedicalHistory.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{pastMedicalHistoryEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pastMedicalHistory.condition">Condition</Translate>
          </dt>
          <dd>{pastMedicalHistoryEntity.condition ? pastMedicalHistoryEntity.condition.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pastMedicalHistory.patient">Patient</Translate>
          </dt>
          <dd>{pastMedicalHistoryEntity.patient ? pastMedicalHistoryEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/past-medical-history" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/past-medical-history/${pastMedicalHistoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PastMedicalHistoryDetail;
